<nb-card accent="info">
    <nb-card-header>
        Proses Absensi
    </nb-card-header>
    <nb-card-body>
        <form [formGroup]="absenForm">
            <div class="form-group">
                <label>Lokasi Absen</label>
                <input type="text" nbInput placeholder="Lokasi absen" id="lokasi" class="form-control"
                    formControlName="lokasi">
            </div>

            <div class="form-group">
                <label>Keterangan</label>
                <textarea type="text" nbInput placeholder="Keterangan" id="keterangan" class="form-control"
                    formControlName="keterangan"></textarea>
            </div>

            <div class="form-group">
                <label>File Pendukung</label>
                <input nbInput type="file" accept="image/*" id="file" class="form-control" formControlName="file"
                    capture="user" (change)="onSelectFile($event)">
                <div class="row mt-3">
                    <div class="col-12 col-md-3">
                        <img [src]="imageUrl" width="100%" height="auto">
                    </div>
                </div>
            </div>

            <div class="btn-group">
                <button nbButton (click)="close()">
                    Batal
                </button>
                <button nbButton status="success" (click)="proceed()" [disabled]="!absenForm.valid">
                    Lanjut
                </button>
            </div>
        </form>
    </nb-card-body>
</nb-card>